// extracted by mini-css-extract-plugin
export default {"navbarLogo":"NavbarLogo_navbarLogo__lvJUG","logoLink":"NavbarLogo_logoLink__rHjul","logoContainer":"NavbarLogo_logoContainer__Y2-gW","logoImage":"NavbarLogo_logoImage__GcpwB"};